import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ITermPinModel } from '../../../interfaces/scheduler_interfaces';

export type TermPinModel = ITypedModel<ITermPinModel>;
angular.module('capability-ng-scheduler').factory(
  'ngTermPinModel',
  () =>
    new Model<ITermPinModel>({
      isPinUpdated: false,
      updatedTermPin: '',
      term_pin: ''
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/term_pin/models/term_pin_model.ts